import plusSVG from "../../Images/+.svg";
import minusSVG from "../../Images/minusIcon.svg";
import webSiteIcon from "../../Images/website_icon.svg";
import wpIcon from "../../Images/whatsapp_icon.svg";
import instaIcon from "../../Images/instagram_icon.svg";
import React, {useEffect, useState} from "react";
import Directions from '../../Images/icon-directions.svg'
import miniPhone from '../../Images/miniphone.svg'

export default ({name, place, phone, address, image, web, whatsapp, instagram, setOpenCard, openCard, setSelectedPoint, point}) => {

    const isMobile = window.matchMedia('(max-width: 700px)')
    const [showCard, setShowCard] = useState(false)
    useEffect(() => {
        console.log('openCardChild', openCard)
        if(openCard !== name){
            setShowCard(false);
        }
    }, [openCard !== name]);
    const shwCard = () => {
        setShowCard(!showCard)
        setOpenCard(name);
        setSelectedPoint(point)
    }

    return (
        <div onClick={() =>
            shwCard()}
             className="block m-2 max-w-sm p-6 bg-[#F7ABB834] md:bg-white hover:bg-[#F7ABB834] border border-gray-200 rounded-lg shadow">
            {showCard &&
                <div className="relative md:h-32 h-52">
                    <img src={minusSVG} alt="plus" className="absolute top-[-7px] right-[-7px] z-10"/>
                    <img className='md:max-h-32 max-h-52 min-w-full absolute top-0 left-0' src={image} alt="image"/>
                </div>
            }
            <div className="flex flex-row font-bold font-display justify-between pt-2">
                {name}
                {!showCard && <img src={plusSVG} alt="plus"/>}
            </div>
            <div>{place}</div>
            {isMobile.matches || showCard ? <>
                <div className="text-sm underline flex my-2">
                    <img src={Directions} alt="directions" className='mr-2'/>{address}
                </div>
                <div className="text-sm underline flex">
                    <img src={miniPhone} alt="directions" className='mr-2'/>{phone}
                </div>
            </> : ''}
            {showCard &&
                <div className={'flex space-x-4 pt-4'}>
                    {web &&
                        <a href={web} target="_blank">
                            <img className="w-6" src={webSiteIcon} alt="logo"/>
                        </a>}
                    {whatsapp &&
                        <a href={whatsapp} target="_blank">
                            <img className="w-6" src={wpIcon} alt="logo"/>
                        </a>}
                    {instagram &&
                        <a href={instagram} target="_blank">
                            <img className="w-6" src={instaIcon} alt="logo"/>
                        </a>}
                </div>
            }
        </div>);
}